/* eslint-disable complexity */
/* eslint-disable no-param-reassign */
import ua from '@tencent/docs-user-agent';
import React, { Component, Fragment, lazy, Suspense } from 'react';
import styles from './status-bar.less';
import Snackbar from '@tencent/dui/lib/components/Snackbar';
import Tooltip from '@tencent/dui/lib/components/Tooltip';
import Divider from '@tencent/dui/lib/components/Divider';
import { observer } from 'mobx-react';
import CheckIcon from '@com-pc/palette-panel/images/border-check.svg';
import { autorun, IReactionDisposer } from 'mobx';
import { getQuery } from 'steamer-browserutils';
import {
    ADAPTER_SCREEN_ICON,
    PAGE_PLUS_ICON,
    LOCALPLAY_START_ICON,
    PAGE_REDUCE_ICON,
    NOTE_AREA_ICON,
    MASTER_LAYOUT_ICON,
} from '../../editor/src/img/pageIndex/index';
import { AppServiceProvider } from '@src/slide/application/app-service-provider';

import Dropdown from '@com-pc/dropdown';
import { browser } from '@src/slide/infrastructure/module/independent/agent/common';
import {
    addKeyMouseEvent,
    removeMouseEvent,
} from '@utils/key-mouse-event';
import { STATUS_BAR_HEIGHT } from '@editor/src/js/constants';
import { tdw } from '@src/slide/infrastructure/module/dependent/report/offline-data-report/tdw-report';
import { registerLongTapReportDialog } from '@src/slide/infrastructure/module/dependent/report/log/weblog-manual';
import { TDWModuleType, TDWOperationType, TDWActionType } from '../../../slide/infrastructure/module/dependent/report/offline-data-report/constant';
import { canvasToPt, ptToCanvas } from '../../../slide/infrastructure/module/independent/unit';
import i18n from '@i18next/i18n';
import { StatusBarConfig } from '@src/slide/infrastructure/module/dependent/config/config-manager-constants';
import appConfigInstance, { setDefaultConfig } from '@src/slide/infrastructure/module/dependent/config/tob/app-config';
import throttle from 'lodash/throttle';
import classNames from 'classnames';
import ErrorBoundary from '@com/error-boundary';
import ENV from '@src/slide/infrastructure/module/dependent/runtime-environment/enviroment';
import { createContinuousClickHandler } from '@src/slide/application/service/history-manager/core/container/snapshot-list';
import { getBrowserZoomLevel } from '@src/utils/browserZoom';
import { PPTEditorStateType } from '@src/slide/domain/ui-model/constant/edit-state-type';
import { EDIT_TYPE } from '@src/slide/domain/selection/constant/edit-type';
import { StatusPageInfo } from '@com-pc/status-page-info';
import { SlideDataServices } from '@src/slide/domain/slide-app/core/slide-data-services.core';
import { EditEvents } from '@src/slide/domain/slide-app/core/interfaces/event.interface';
import { IPcEditorAppServices } from '@src/slide/application/entry/toc/editor/pc/pc-editor-app-services.interface';
import { IStatePointEnum } from '@src/slide/application/service/slide-render-state/slide-render-state-manager.interface';

const RemotePlayButton = lazy(() => import(/* webpackChunkName: "tencent-meeting" */ '@tencent/docs-scenario-components-meeting-remote-play-button'));
const actionPlus = 'action_plus';
const actionReduce = 'action_reduce';
const actionAuto = 'action_auto';
const actionNote = 'action_note';
const actionPlay = 'action_play';
const actionMaster = 'action_master';

const scaleSlidePercent = [
    { id: '50', title: '50%' },
    { id: '75', title: '75%' },
    { id: '100', title: '100%' },
    { id: '125', title: '125%' },
    { id: '150', title: '150%' },
    { id: '200', title: '200%' },
    { id: '300', title: '300%' },
    { id: '400', title: '400%' },
];

const isSpeaker = getQuery('login') === 'speaker';

interface StatusBarState {
    isSnapshotListVisible: boolean;
    toolTipShow: boolean;
    showPlayBtn: boolean;
    showToggleEditTypeBtn: boolean;
}

@observer
class StatusBar extends Component<{}, StatusBarState> {
    private showPlayBtnDef = setDefaultConfig(appConfigInstance.getConfig(StatusBarConfig.playBtn as any), true);
    private lastScale: number;
    private snackBarToast: ReturnType<typeof Snackbar.show>;
    /**
     * toast提示（加入节流，保证toast不会重复出现）
     * @message 提示显示的文案
     */
    private showToast = throttle((message) => {
        this.snackBarToast = Snackbar.show({
            message,
            duration: 1000,
        });
    }, 1100);
    private handlePageInfoClick;
    private shortcutAutorun?: IReactionDisposer;
    private dropDom: Dropdown|null;

    public constructor(props) {
        super(props);
        this.handlePageInfoClick = createContinuousClickHandler(this.showSnapshotList, 5);
        const canEdit = this.getUserPriviledgeService().pptEditorState <= PPTEditorStateType.EDITABLE;
        this.state = {
            toolTipShow: false,
            showPlayBtn: this.showPlayBtnDef,
            isSnapshotListVisible: false,
            showToggleEditTypeBtn: canEdit,
        };
        this.lastScale = 0;

        this.addHistoryManagerEventListener();
        this.getUserPriviledgeService().onPPTEditorStateChange((state) => {
            this.setState({
                showToggleEditTypeBtn: state <= PPTEditorStateType.EDITABLE,
            });
        });
    }

    public componentDidUpdate() {
        this.reportAfterRender();
    }

    public componentWillUnmount() {
        const shortcut = this.getShortCut().key;
        window.removeEventListener('keydown', this.handlePlusReduceShortCut);
        window.removeEventListener('wheel', this.handleMouseWheel);
        removeMouseEvent(shortcut, this.handleKeyDown);
        this.shortcutAutorun?.();
    }

    public componentDidMount() {
        this.shortcutAutorun = autorun(() => {
            this.handleShowRatioView();
        });
        const shortcut = this.getShortCut().key;
        addKeyMouseEvent(shortcut, this.handleKeyDown);
        this.reportAfterRender();
        window.addEventListener('keydown', this.handlePlusReduceShortCut);
        window.addEventListener('wheel', this.handleMouseWheel, { passive: false });
        setTimeout(() => {
            const preFooter = document.querySelector('.pre-footer');
            preFooter && ((preFooter as HTMLElement).style.display = 'none');
        });
    }

    public render() {
        const { showPlayBtn, showToggleEditTypeBtn } = this.state;
        let scale = ptToCanvas(this.getAppServices().viewableServiceLayer.editAreaCanvasSizeManager.getCanvasScale());
        scale = Math.round(Number(scale.toFixed(2)) * 100);
        const scaleInfo = `${scale}%`;

        const shortCut = this.getShortCut().title;

        const noteShow = !!(this.getNoteAreaManager()
                && this.getNoteAreaManager().show);
        const isMasterShow = this.getMasterLayoutEditService()?.isMasterEditType;

        return (
            <div className={styles.statusBar} onMouseDown={this.preventBlur} style={{ height: STATUS_BAR_HEIGHT }}>
                <StatusPageInfo handlePageInfoClick={this.handlePageInfoClick} />
                <span className={styles.paddingRight}/>
                <Tooltip
                    title={i18n.t('{0}可恢复至100%', { 0: shortCut })}
                    visible={this.state.toolTipShow}
                    style={{ float: 'right', marginRight: -2, lineHeight: '30px' }} placement={'top'}
                    offset={-27} overlayStyle={{ wordBreak: 'keep-all' }}>
                    <div onMouseLeave={this.handleMouseLeave}
                        onMouseEnter={this.handleMouseEnter}>
                        <div className={styles['icon-container']}>
                            <img className={styles.scaleReduce} src={PAGE_REDUCE_ICON}
                                onClick = {() => this.handleMouseDown(actionReduce)}
                            />
                        </div>
                        <span className={styles.scaleNumber} id={'adjust-slide-size-id'}>{scaleInfo}</span>
                        <div className={styles['icon-container']}>
                            <img className={styles.scalePuls} src={PAGE_PLUS_ICON}
                                onClick = {() => this.handleMouseDown(actionPlus)}
                            />
                        </div>
                    </div>
                </Tooltip>
                <Tooltip
                    title={i18n.t('按当前窗口调整幻灯片大小')}
                    trigger="hover"
                    style={{ float: 'right', margin: '0 12px' }} placement={'top'} >
                    <div
                        className={styles['icon-container']}>
                        <img src={ADAPTER_SCREEN_ICON} id={'status-bar-adapter-screen'}
                            className={styles.adapterImg} onClick = {() => this.handleMouseDown(actionAuto)}/></div>
                </Tooltip>
                <Divider orientation="vertical" style={{
                    float: 'right', verticalAlign: 'middle', backgroundColor: 'rgba(0, 0, 0, 0.08)', margin: '8px 0',
                }} />
                {
                    showPlayBtn && <Fragment>
                        <Tooltip
                            title={i18n.t('开始演示')}
                            trigger="hover" style={{ float: 'right', margin: '0 12px' }} placement={'top'} >
                            <div
                                className={styles['icon-container']}>
                                <img src={LOCALPLAY_START_ICON} id={'status-bar-start-play'}
                                    className={styles.adapterImg}
                                    onClick = {() => this.handleMouseDown(actionPlay)}/></div>
                        </Tooltip>
                        <Divider
                            orientation="vertical"
                            style={{
                                float: 'right',
                                verticalAlign: 'middle', backgroundColor: 'rgba(0, 0, 0, 0.08)', margin: '8px 0',
                            }} />
                    </Fragment>
                }
                {
                    ua.isTencentMeeting && isSpeaker && <Fragment>
                        <div style={{ float: 'right', margin: '4px 12px 0' }}>
                            <ErrorBoundary>
                                <Suspense fallback={<div></div>}>
                                    <RemotePlayButton
                                        padType="slide"
                                        iconType="STATUS_BUTTON"
                                    />
                                </Suspense>
                            </ErrorBoundary>
                        </div>
                        <Divider orientation="vertical"
                            style={{
                                float: 'right',
                                verticalAlign: 'middle', backgroundColor: 'rgba(0, 0, 0, 0.08)', margin: '8px 0',
                            }} />
                    </Fragment>
                }
                <Tooltip
                    title={ noteShow ? i18n.t('关闭备注') : i18n.t('打开备注') }
                    trigger="hover"
                    style={{
                        float: 'right',
                        margin: '0 12px',
                        position: 'relative',
                    }}
                    placement={'top'}
                >
                    <div
                        className={classNames({
                            [styles['icon-container']]: true,
                            [styles['icon-container-active']]: !!noteShow,
                            [styles['icon-container-disabled']]: isMasterShow,
                        })}
                    >
                        <img
                            className={styles['note-area-icon']}
                            src={NOTE_AREA_ICON}
                            onClick={() => !isMasterShow && this.handleMouseDown(actionNote, noteShow)}
                        />
                    </div>
                </Tooltip>
                { showToggleEditTypeBtn && <Tooltip
                    title={ isMasterShow ? i18n.t('关闭母版') : i18n.t('母版编辑') }
                    trigger="hover"
                    style={{
                        float: 'right',
                        marginLeft: '12px',
                        position: 'relative',
                    }}
                    placement={'top'}
                >
                    <div
                        className={classNames({
                            [styles['icon-container']]: true,
                            [styles['icon-container-active']]: isMasterShow,
                        })}
                        {...registerLongTapReportDialog()}
                    >
                        <img
                            className={styles['note-area-icon']}
                            src={MASTER_LAYOUT_ICON}
                            onClick={() => this.handleMouseDown(actionMaster, isMasterShow)}
                        />
                    </div>
                </Tooltip> }
                { this.shouldShowFlag() ?  <div style={{ float: 'right', margin: '0 4px', display: 'flex', alignItems: 'center', height: '100%' }}>
                    <span
                        onClick={() => this.getAppServices().getUiDataService().operationLogger?.exportAndDownload()}
                        style={{
                            fontSize: 14,
                            color: 'deepskyblue',
                            fontWeight: 'bold',
                            fontFamily: '-apple-system,'
                                + 'PingFang SC,'
                                + 'Microsoft YaHei,Source Han Sans SC,Noto Sans CJK SC,WenQuanYi Micro Hei,sans-serif' }}>Data 3.0</span>
                </div> : null }
                <Dropdown belongID={'adjust-slide-size-id'} shadowType={'menu'} ref={(ref) => {
                    this.dropDom = ref;
                }}
                onVisibleChange={this.onVisibleChange} aligment={'top'} center={true}>
                    <ul>
                        {scaleSlidePercent.map((item) => {
                            const selectDisplay = parseInt(item.id, 10) === scale ? 'visible' : 'hidden';
                            return <li key={item.id} className={styles['menu-item']} onClick={() => this.handleItemClick(item)}>
                                <img className={styles['item-select-img']} src={CheckIcon} style={{ visibility: selectDisplay }}/>
                                <span className={styles['border-item-text']}>{item.title}</span>
                            </li>;
                        })}
                    </ul>
                </Dropdown>
            </div>
        );
    }

    /** 监听修订记录事件，查看修订记录面板时禁止播放 */
    private addHistoryManagerEventListener() {
        this.getAppServices().editableServiceLayer?.historyManager.on('show', () => {
            this.setState({ showPlayBtn: false, showToggleEditTypeBtn: false });
        });
        this.getAppServices().editableServiceLayer?.historyManager.on('hide', () => {
            const canEdit = this.getUserPriviledgeService().pptEditorState === PPTEditorStateType.EDITABLE;
            this.setState({ showPlayBtn: this.showPlayBtnDef, showToggleEditTypeBtn: canEdit });
        });
    }

    private handleShowRatioView() {
        const number = this.getMenuManager()?.showRatioViewAction;
        if (number) {
            if (this.dropDom) {
                setTimeout(() => {
                    this.dropDom?.show();
                }, 200);
            }
        }
    }

    /**
     * 加减，注册快捷键。注意：注册到通用的全局快捷键会有查看权限不生效问题
     */
    private handlePlusReduceShortCut = async (e: KeyboardEvent) => {
        const { keyCode } = e;
        // 按住ctrl或command才进入流程
        if (e.ctrlKey || e.metaKey) {
            const shortCutKeyManager = await this.getAppServices().viewableServiceLayer.shortCutKeyManager.promise();
            if (shortCutKeyManager.shouldShortcutKeyActive()) {
                // 只有在浏览器缩放为100%的时候才修改快捷键的行为
                if (getBrowserZoomLevel() !== 100) {
                    return;
                }
                // 火狐的主键盘=是61，减号是173
                if (keyCode === 109 || keyCode === 189 || keyCode === 173) {
                    // 减号
                    e.preventDefault();
                    this.handleMouseDown(actionReduce);
                } else if (keyCode === 107 || keyCode === 187 || keyCode === 61) {
                    // 加或=号
                    e.preventDefault();
                    this.handleMouseDown(actionPlus);
                }
            } else {
                // 若编辑区禁止使用 slide 快捷键，同时也禁用快捷键的默认缩放行为
                if ([61, 107, 109, 187, 189, 173].includes(keyCode)) {
                    e.preventDefault();
                }
            }
        }
    };

    private handleMouseWheel = async (e) => {
        // 滚轮事件和 ctrl + '+' 走一样的逻辑
        const shortCutKeyManager = await this.getAppServices().viewableServiceLayer.shortCutKeyManager.promise();
        if (e.ctrlKey || e.metaKey) { // 按住ctrl或command
            const down = e.wheelDelta ? e.wheelDelta < 0 : e.detail > 0;
            // 阻止默认事件
            e?.preventDefault();
            if (shortCutKeyManager.shouldShortcutKeyActive()) {
                if (down) {
                    this.handleMouseDown(actionReduce);
                } else {
                    this.handleMouseDown(actionPlus);
                }
            }
        }
    };

    private handleKeyDown = () => {
        this.getAppServices()
            .viewableServiceLayer.editAreaCanvasSizeManager.setCanvasScaleAndIsAutoAdapter(canvasToPt(1), false);
        window.dispatchEvent(new CustomEvent('resize', { detail: { countSizeAgain: true } })); // 主动触发window resize
    };

    private mouseDownByPlus(scale) {
        if (scale + 0.05 > 4) {
            this.showToast(i18n.t('已拉伸至最大值'));
        } else {
            scale = this.computeScale(scale, true);
        }
        this.getAppServices()
            .viewableServiceLayer.editAreaCanvasSizeManager.setCanvasScaleAndIsAutoAdapter(canvasToPt(scale), false);
        window.dispatchEvent(new CustomEvent('resize', { detail: { countSizeAgain: true } })); // 主动触发window resize
    }

    private mouseDownByReduce(scale) {
        if (scale - 0.05 <= 0.1) {
            scale = 0.1;
            this.showToast(i18n.t('已拉伸至最小比例'));
        } else {
            // scale-= 0.05;
            scale = this.computeScale(scale, false);
        }
        this.getAppServices()
            .viewableServiceLayer.editAreaCanvasSizeManager.setCanvasScaleAndIsAutoAdapter(canvasToPt(scale), false);
        window.dispatchEvent(new CustomEvent('resize', { detail: { countSizeAgain: true } })); // 主动触发window resize
    }

    private mouseDownByAuto() {
        this.getAppServices()
            .viewableServiceLayer.editAreaCanvasSizeManager.setIsAutoAdapter(true);
        window.dispatchEvent(new CustomEvent('resize', { detail: { countSizeAgain: true } })); // 主动触发window resize
        tdw({
            opername: TDWOperationType.DOC_PPT,
            module: TDWModuleType.PC_OBJ,
            action: TDWActionType.ADAPT,
        });
    }

    private mouseDownByNote(rest) {
        // eslint-disable-next-line no-case-declarations
        const show = !!(rest?.[0]);
        if (show) {
            this.getNoteAreaManager().setHide();
        } else {
            this.getNoteAreaManager().setShow();
        }
    }

    private mouseDownByPlay() {
        if (this.getAppServices().viewableServiceLayer.slideRenderStateManager
            .getStatePoints()[IStatePointEnum.allSlideConvert].isCompleted) {
            this.getAppServices().viewableServiceLayer.playManager.playAction?.(true);
        } else {
            Snackbar.show({
                message: i18n.t('加载幻灯片中，请稍后再试'),
                duration: 3000,
            });
        }
    }

    /**
     * 切换当前编辑模式
     */
    private mouseDownByToggleEditType() {
        const isMasterEditType = this.getMasterLayoutEditService()?.isMasterEditType;

        this.getAppServices().editableServiceLayer
            ?.masterLayoutEditService?.changeEditType(isMasterEditType ? EDIT_TYPE.SLIDE : EDIT_TYPE.MASTER_LAYOUT);
        tdw({
            opername: TDWOperationType.DOC_PPT,
            module: TDWModuleType.MASTER,
            action: TDWActionType.MASTER_CLICK,
        });
    }

    private handleMouseDown = async (type, ...rest) => {
        const scale = ptToCanvas(this.getAppServices()
            .viewableServiceLayer.editAreaCanvasSizeManager.getCanvasScale());
        switch (type) {
            case actionPlus:
                this.mouseDownByPlus(scale);
                break;
            case actionReduce:
                this.mouseDownByReduce(scale);
                break;
            case actionAuto:
                this.mouseDownByAuto();
                break;
            case actionNote:
                this.mouseDownByNote(rest);
                break;
            case actionPlay:
                this.mouseDownByPlay();
                break;
            case actionMaster:
                this.mouseDownByToggleEditType();
                break;
        }
    };

    private computeScale = (scale, add) => {
        const interval = 0.05;
        if (add) {
            scale += interval;
        }
        let scaleStr = `${scale.toFixed(2)}`;
        const len = scaleStr.length;
        const headStr = scaleStr.substring(0, len - 1);
        let lastStr: number|string = scaleStr.substring(len - 1, len);
        if (lastStr === '0' || lastStr === '5') {
            if (!add) {
                scale -= interval;
            }
            return scale;
        }
        if (Number(lastStr) > 5) {
            lastStr = 5;
        } else if (Number(lastStr) > 0) {
            lastStr = 0;
        }
        scaleStr = headStr + lastStr;
        return parseFloat(scaleStr);
    };

    private handleItemClick = (item) => {
        const scale = parseFloat(canvasToPt(item.id / 100) as unknown as string);
        this.getAppServices()
            .viewableServiceLayer.editAreaCanvasSizeManager.setCanvasScaleAndIsAutoAdapter(scale, false);
        window.dispatchEvent(new CustomEvent('resize', { detail: { countSizeAgain: true } })); // 主动触发window resize
        this.hideDropDown();
    };

    private hideDropDown = () => {
        if (this.dropDom) {
            this.dropDom.hide();
        }
    };

    private onVisibleChange = (visible) => {
        const menuManager = this.getMenuManager();
        if (menuManager) {
            menuManager.isDropdownShown = visible;
        }
        if (visible) {
            this.setState({
                toolTipShow: !visible,
            });
        }
    };

    private getShortCut() {
        return browser.isMac ? { key: 'command+0', title: 'Cmd+0' } : { key: 'ctrl+0', title: 'Ctrl+0' };
    }

    private preventBlur = (e) => {
        e.preventDefault(); // 配合onMouseDown，不触发blur
        this.getAppServices().viewableServiceLayer.toolbarStateManager.isClickOnToolbar = true;
    };

    private reportAfterRender = () => {
        let scale = Number(this.getAppServices()?.viewableServiceLayer?.editAreaCanvasSizeManager
            .getCanvasScale().toFixed(2) || 0) * 100;
        scale = Math.round(scale);
        if (scale !== this.lastScale) {
            this.lastScale = scale;
            let actionName: string|null = null;
            if (scale > 100) {
                actionName = TDWActionType.AMP;
            } else if (scale < 100) {
                actionName = TDWActionType.REDUCE;
            }
            if (actionName) {
                tdw({
                    opername: TDWOperationType.DOC_PPT,
                    module: TDWModuleType.PC_OBJ,
                    action: actionName,
                });
            }
        }
        if (this.state.showToggleEditTypeBtn) {
            tdw({
                opername: TDWOperationType.DOC_PPT,
                module: TDWModuleType.MASTER,
                action: TDWActionType.MASTER_VIEW,
            });
        }
    };

    private handleMouseEnter = () => {
        this.setState({ toolTipShow: true });
    };

    private handleMouseLeave = () => {
        this.setState({ toolTipShow: false });
    };

    private showSnapshotList = () => {
        SlideDataServices.EventManager()?.emit(EditEvents.ShowSnapShotModal);
    };

    private getAppServices = () => AppServiceProvider.getInstance().getAppServices() as IPcEditorAppServices;


    private getUserPriviledgeService = () => this.getAppServices().viewableServiceLayer.userPriviledgeService;

    private getMasterLayoutEditService = () => this.getAppServices().editableServiceLayer?.masterLayoutEditService;

    private getNoteAreaManager = () => this.getAppServices().viewableServiceLayer.noteAreaManager;

    private getMenuManager = () => this.getAppServices().editableServiceLayer?.menuManager;

    /**
     * 是否显示canvas标识。
     * 条件： 1. 是dev版本
     *       2. 设置了测试环境id
     * @returns {boolean | *}
     */
    // eslint-disable-next-line no-undef
    private shouldShowFlag = () => (__IS_DEV__ || ENV.IS_TEST);
}

export default StatusBar;
